import type {
  CSSProperties,
  ElementType,
  HTMLAttributes,
  ReactNode,
} from "react";
import "./LayoutPrimitives.scss";

type FlexProps = HTMLAttributes<HTMLElement> & {
  align?: CSSProperties["alignItems"];
  as?: ElementType;
  children?: ReactNode;
  direction?: CSSProperties["flexDirection"];
  gap?: CSSProperties["gap"];
  justify?: CSSProperties["justifyContent"];
  wrap?: CSSProperties["flexWrap"];
};

export function Flex({
  align,
  as: Component = "div",
  children,
  className = "",
  direction,
  gap,
  justify,
  style,
  wrap,
  ...props
}: FlexProps) {
  return (
    <Component
      className={`layout-flex ${className}`.trim()}
      style={{
        ...style,
        ...(align === undefined ? {} : { alignItems: align }),
        ...(direction === undefined ? {} : { flexDirection: direction }),
        ...(wrap === undefined ? {} : { flexWrap: wrap }),
        ...(gap === undefined ? {} : { gap }),
        ...(justify === undefined ? {} : { justifyContent: justify }),
      }}
      {...props}
    >
      {children}
    </Component>
  );
}
